import React, { useState, useRef, useEffect, useImperativeHandle } from "react";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../components/loader/loader";
import NoRecord from "../../components/NoDataScreen/NoRecord";
import Pagination from "../../components/pagination/pagination";
import { ApiUrl } from "../../config/apiConfig";
import { PaginationControls } from "../../models/pagination";
import { getData, postData } from "../../services/Axios/Axios";
import messageService from "../../services/message/messageService";
import AddMarketNewRelease from "../MarketNewRelease/AddMarketNewRelease";
import icon from "../../assets/img/downbtn.svg";
import { useLocation } from "react-router-dom";
import SelectPlantype from "./SelectPlantype";
import { ChevronsUpDown } from "lucide-react";
import EditButton from "../../components/UIElements/EditButton";





interface NewList {
  allData: any;
  setAllData: any
}

const ListPlan = React.forwardRef((props: NewList, ref) => {
  const { show, hide } = useLoader();

  const [searchdata, setSearchQuery] = useState<any>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [SinglePlan, setMarkePlan] = useState("");
  const hide3 = useRef<any>(null);
  const [getuser_id, setuser_id] = useState<any>("");

  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);
  const [sortConfig, setSortConfig] = useState({
    key: "company_name",
    direction: "ascending",
  });

  const [singleUser, setsingleUser] = useState<any>("");


  const [formData, setFormData] = useState<any>({
    title: "",
    sub_title: "",
    plan_reference_description: "",
    price: "",
    duration: "",
    user_count: "",
    load_count: "",
    asset_count: "",
    driver_count: "",
    truck_count: "",
    trailer_count: "",
    addon_price: "",
    is_add_on: "",
    plan_type: "",
  });

  const addEditModalOpen = (data?: any) => {
    if (data) {
      setsingleUser(data);
      setIsModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };
  const closeModal = () => {


    // setFormData({
    //     sub_title:   "",
    //     price:  "",
    //     duration: "",
    //     user_count:   "",
    //     truck_count:   "",
    //     addon_price:   "",
    //     is_add_on:  "",
    //     plan_type:  "",
    //     add_on_truck_count: "",
    //   });

    setIsModalOpen(false);
    setuser_id("");
  };

  const navigate = useNavigate();
  useEffect(() => {
    getDataALL();

    return () => { };
  }, [pagination.page,]);

  const getDataALL = async (searchdata?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    if (searchdata) {
      obj.search = searchdata;
    }
    try {
      const response = await getData(ApiUrl.listPlans, obj, {
        show,
        hide,
      });
      console.log(response);
      props.setAllData(response.data);

      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );
    } catch (error) { }
  };

  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  useImperativeHandle(ref, () => ({
    getDataALL,

    handleSearchSubmit,
    handleSearchChange,
  }));

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    getDataALL(searchdata);
  };


  const addEdit = (data?: any) => {
    console.log("object");
    setMarkePlan(data);
    setIsModalOpen(true);
  };






  return (
    <>

      <div className="loadlist">
        <div className="tablebox w-100">
          <div className="tablebox12">
            <div className="scrollbar-box newclassscroll">
              <div className="overflow-x-auto ">
                <table className="border-collapse  text-black w-full">
                  <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                    <tr className="text-[13px] font-bold  bg-customGray">
                      <th className="px-3 py-2 text-center border border-[#E2E2E2] ">
                        <div className="flex items-center justify-between">
                          <span>S. No</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Plan Name</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Description</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>User limit</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Truck  limit</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Price</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>
                      <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Plan Type</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Add on Price</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>

                      <th className=" px-3 py-2 text-center border border-[#E2E2E2]">
                        <div className="flex items-center justify-between">
                          <span>Add on Truck</span>
                          <ChevronsUpDown size="12px" />
                        </div>
                      </th>


                      <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                    {props.allData.map((data: any, index: number) => (
                      <tr key={index} className="text-[12px]">
                        <td className="  px-3  border border-[#E2E2E2]">
                          {startIndex + index}
                        </td>
                        <td className=" px-3 border border-[#E2E2E2]">
                          {data?.title ? data?.title : '--'}</td>
                        <td className="px-3 border border-[#E2E2E2]">
                          {data?.sub_title ? data?.sub_title : '--'}
                        </td>
                        <td className=" px-3 border border-[#E2E2E2]">{data?.user_count ? data?.user_count : '--'}</td>
                        <td className=" px-3 border border-[#E2E2E2]">{data?.truck_count ? data?.truck_count : '--'}</td>
                        <td className=" px-2 border border-[#E2E2E2]"> {data?.price && data.price > 0 ? `$${data.price.toFixed(2)}` : '--'}</td>
                        <td className=" px-2 border border-[#E2E2E2]">
                          {data?.duration ? data?.duration : '--'}
                        </td>
                        <td className=" px-2 border border-[#E2E2E2]">
                          {data?.addon_price && data.addon_price > 0 ? `$${data.addon_price.toFixed(2)}` : '--'}
                        </td>


                        <td className=" px-2 border border-[#E2E2E2]">
                          {data?.add_on_truck_count ? data?.add_on_truck_count : '--'}
                        </td>

                        <td className=" text-center  items-center px-2 py-[2px] border border-[#E2E2E2]">
                          <div className=" w-full flex justify-center gap-1 items-center ">
                          <EditButton onClick={() => addEdit(data)} />
                           
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {!props.allData && (
                <NoRecord noDataText="No data available in Plan" />
              )}
            </div>
          </div>
          {props.allData.length > 0 && (
            <Pagination pagination={pagination} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
      <SelectPlantype
        isOpen={isModalOpen}
        SinglePlan={SinglePlan}
        closeModal={closeModal}
        getDataALLs={getDataALL}
        formData={formData}
        setFormData={setFormData}
        getuser_id={getuser_id}
        setuser_id={setuser_id}
      />
    </>
  );
});

export default ListPlan;
